import React from 'react';
import {
  getHeaderValue,
  ALL_MODULES,
  getDownloadURL,
  EventEmitter,
  withErrorBoundary,
  Loader,
  toast,
  fetchApi,
  isAuthorised,
  AppContext,
  EventEmitterWithIndex,
  getTranslatedText
} from '@nile/components';
import Tribute from 'tributejs';
import 'tributejs/src/tribute.scss';
import './CustomAttachmentsPlugin';
import envConfig from '@nile/home/src/Config/env';
import { injectIntl } from 'react-intl';
import { getSubjectPlaceholdersObj } from '@nile/banyan/src/Pebbles/subjectPlaceholders';
import { restructureHtml } from '@nile/components/src/Utils/helpers';
// Require Editor JS files.
import 'froala-editor/js/froala_editor.pkgd.min';
import 'froala-editor/js/plugins/image.min';
import 'froala-editor/js/plugins/file.min';
import 'froala-editor/js/plugins/files_manager.min';
import 'froala-editor/js/plugins/font_family.min';
import 'froala-editor/js/plugins/colors.min';
import 'froala-editor/js/plugins/font_size.min';
import 'froala-editor/js/plugins/paragraph_format.min';
import 'froala-editor/js/plugins/paragraph_style.min';
import 'froala-editor/js/plugins/lists.min';
import 'froala-editor/js/plugins/align.min';
import 'froala-editor/js/plugins/emoticons.min';
import 'froala-editor/js/plugins/link.min';
import 'froala-editor/js/plugins/table.min';

// Require Editor CSS files.
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/css/plugins/emoticons.min.css';

// Require Font Awesome.
// import 'font-awesome/css/font-awesome.css';

import styled from 'styled-components';
import FroalaEditor from 'react-froala-wysiwyg';
import { cloneDeep, isEqual } from 'lodash';
import CustomPromptModal from '@nile/components/src/Modals/CustomPromptModal';
import { Link } from '@superops/ui-design-system';
import { AccountClient, GET_ALL_TECHS_NEW } from '@nile/graphql';

// Include special components if required.
// import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView';
// import FroalaEditorA from 'react-froala-wysiwyg/FroalaEditorA';
// import FroalaEditorButton from 'react-froala-wysiwyg/FroalaEditorButton';
// import FroalaEditorImg from 'react-froala-wysiwyg/FroalaEditorImg';
// import FroalaEditorInput from 'react-froala-wysiwyg/FroalaEditorInput';

// Render Froala Editor component.

const AttachmentsHolder = styled.div`
  gap: 10px;
  height: ${(props) => (props.hasAttachments ? '65px' : '0px')};
  overflow: scroll;

  // border: 1px solid #ccc;
  border: none;
  border-top: none;
  padding: ${(props) => (props.hasAttachments ? '5px 5px 5px 0' : '0px')};
`;

const EditorWrapper = styled.div`
  min-height: inherit;

  .fr-box.fr-basic {
    display: flex;
    flex-direction: column;
    border-radius: 0 !important;
    transition: height 0.5s ease-in 0.1s;
    min-height: inherit;
    height: ${(props) =>
      props.hasAttachments ? `calc(100% - 65px) !important` : `100%`};

    .fr-wrapper {
      background: transparent;
      flex-grow: 1;
      height: calc(100% - 50px);
      border: none;
      border-radius: 0 !important;
      transition: height 0.5s ease-in 0.5s;
      .fr-view {
        padding: 0 0 20px;
      }
      &.show-placeholder .fr-placeholder {
        font-size: 13px !important;
        font-style: italic !important;
        color: rgba(0, 0, 0, 0.6) !important;
      }
    }
    .fr-more-toolbar {
      margin-top: -48px;
      width: auto;
      padding-right: 12px;
      border-radius: 10px;
    }
    &.fr-toolbar-open .fr-wrapper {
      // height: calc(100% - 100px) !important;
    }

    .fr-toolbar {
      background: transparent;
    }
    .fr-toolbar.fr-bottom {
      border: none !important;
      .fr-newline {
        display: none;
      }
    }
  }
`;

export const AttachmentItemHolder = styled.div`
  display: inline-flex;
  background-color: #f2f2f7;
  border-radius: 8px;
  /* margin: 1rem; */
  margin-top: 0;
  word-break: break-word;
  .Polaris-Link {
    display: flex;
    align-items: center;
    padding: 1rem;
    padding-right: 0.2rem;
  }
  &:hover {
    cursor: pointer;
  }
  .close-action {
    border-radius: 0 8px 8px 0;
    padding: 1rem;
    display: flex;
    align-items: center;
    &:hover {
      background-color: #ffbdad;
      color: #de350b;
    }
  }
`;

let tribute;

const AttachmentItem = ({
  fileName,
  originalFileName,
  handleAttachmentsDeletion,
  template,
  module: parentModule,
  disableDownload,
  takeSnapshot
}) => {
  const module = parentModule || ALL_MODULES.notificationTemplateAttachment;
  const details = {
    fileName: fileName
  };

  switch (module) {
    case ALL_MODULES.notificationTemplateAttachment:
      details.templateId = template?.id;
      details.type = template?.templateType;
      break;
    case 'PROJECT_TEMPLATE_ATTACHMENT':
      details.projectTemplateId = template?.id;
      break;
    default:
      break;
  }
  const url = getDownloadURL({ module, details });

  return (
    <AttachmentItemHolder>
      <Link removeUnderline url={!disableDownload && url}>
        {originalFileName}
      </Link>
      <div
        className="close-action"
        onClick={() => handleAttachmentsDeletion(fileName)}
      >
        x
      </div>
    </AttachmentItemHolder>
  );
};

const UPDATE_TEMPLATE_TIMEOUT = 10;
class Editor extends React.Component {
  static contextType = AppContext;

  insertEventEmitterIndex = null;

  constructor(props) {
    super(props);
    // this.handleModelChange = this.handleModelChange.bind(this);

    const FroalaEditorRef = React.createRef();
    const tempRef = React.createRef();
    tempRef.current = {
      placeholdersUsed: props?.template?.placeholdersUsed || '{}',
      mentions: props?.template?.mentions || []
    };
    let imageUploadCompleteTimer = null;

    let editorFileOption = ['insertLink'];
    const imagesLoading = [];
    if (!props.disableAttachment) {
      editorFileOption = [...editorFileOption, 'attachFile'];
    }
    if (!props.disableImageUpload) {
      editorFileOption = [...editorFileOption, 'insertImage'];
    }
    if (props.enableScreenShot) {
      editorFileOption = [...editorFileOption, 'takeSnapshot'];
    }

    const collections = [
      {
        trigger: '@',
        lookup: 'key',
        selectTemplate: ({ original }) => {
          const mentionsData = cloneDeep(this.tempRef.current?.mentions);
          let updatedMentions = cloneDeep(mentionsData || []);

          if (updatedMentions) {
            if (
              !updatedMentions.find((ment) => ment?.userId === original?.value)
            ) {
              updatedMentions = [
                ...updatedMentions,
                { userId: original?.value }
              ];
            }
          }

          this.tempRef.current = {
            ...this.tempRef.current,
            mentions: updatedMentions
          };

          return `<span data-denotation-char="@" data-id=${original?.value} data-value=${original?.key} class="fr-deletable fr-tribute mention" contenteditable="false" >@${original.key}</span>`;
        },
        values: []
      },
      {
        trigger: '#',
        lookup: 'display',
        fillAttr: 'display',
        menuItemTemplate: ({ original }) => {
          return original?.display;
        },
        selectTemplate: ({ original }) => {
          const placeholdersData = cloneDeep(
            this.tempRef.current?.placeholdersUsed
          );
          const updatedPlaceholders = JSON.parse(placeholdersData || '{}');

          if (updatedPlaceholders) {
            if (!updatedPlaceholders.content) {
              updatedPlaceholders.content = {};
            }
            if (!updatedPlaceholders.content[original?.id]) {
              updatedPlaceholders.content[original.id] = original.value;
            }
          }

          this.tempRef.current = {
            ...this.tempRef.current,
            placeholdersUsed: JSON.stringify(updatedPlaceholders)
          };

          return `<span data-denotation-char="#" data-id="${original?.id}" data-value="${original?.value}" class="fr-deletable fr-tribute mention" contenteditable="false">#${original.value}</span>`;
        },
        values: []
      }
    ];

    tribute = new Tribute({
      menuContainer: document.body,
      collection: collections.filter((coll) => {
        if (coll?.trigger === '@') {
          return !!props?.allowMentions;
        }
        if (coll?.trigger === '#') {
          return !!props?.allowPlaceholders;
        }
        return true;
      })
    });

    const additionalConfig = props?.config || {};
    this.config = {
      app: 'SuperOps',
      docId: 'mydoc',
      username: 'Superops.ai',
      key:
        'jUA1yC3C4D2E2G2B2E1qYFa1UQRFQIVc2MSMd1IWPNb1IFd1yD2I2D1C2C7E2C1C5G1F1==',
      heightMin: 200,
      placeholderText: props.placeholder ? props.placeholder : null,
      pluginsEnabled: [
        'align',
        'charCounter',
        'codeBeautifier',
        'codeView',
        'colors',
        'draggable',
        'embedly',
        'emoticons',
        'entities',
        'file',
        'fontAwesome',
        'fontFamily',
        'fontSize',
        'fullscreen',
        'image',
        'imageTUI',
        'imageManager',
        'filesManager',
        'inlineStyle',
        'inlineClass',
        'lineBreaker',
        'lineHeight',
        'link',
        'lists',
        'paragraphFormat',
        'paragraphStyle',
        'quickInsert',
        'quote',
        'save',
        'table',
        'url',
        'video',
        'wordPaste',
        'customPlugin'
      ],
      toolbarBottom: true,
      toolbarButtons: {
        moreText: {
          buttons: [
            'bold',
            'italic',
            'underline',
            // 'strikeThrough',
            // 'subscript',
            // 'superscript',
            'fontFamily',
            'fontSize',
            'textColor',
            'backgroundColor',
            'inlineClass',
            'inlineStyle',
            'clearFormatting'
          ]
        },
        moreTable: {
          buttons: ['insertTable']
        },
        moreParagraph: {
          buttons: [
            'alignLeft',
            'alignCenter',
            // 'formatOLSimple',
            // 'formatULSimple',
            'alignRight',
            'alignJustify',
            'formatOL',
            'formatUL',
            'paragraphFormat',
            // 'paragraphStyle',
            // 'lineHeight',
            // 'outdent',
            // 'indent',
            'quote'
          ],
          buttonsVisible: 0
        },

        moreRich: {
          buttons: editorFileOption,
          buttonsVisible: 4
        },

        moreMisc: {
          buttons: ['emoticons', 'undo', 'redo'],
          // align: 'right',
          buttonsVisible: 3
        }
      },
      tableEditButtons: [
        'tableHeader',
        'tableRemove',
        'tableRows',
        'tableColumns',
        'tableCells',
        'tableCellBackground',
        'tableCellVerticalAlign',
        'tableCellHorizontalAlign'
      ],

      imagePaste: !props.disableImageUpload,

      linkList: [],
      linkInsertButtons: [],
      emoticonsUseImage: false,
      // If not set, tab will navigate through page.
      tabSpaces: 4,
      fontSizeSelection: true,
      paragraphFormatSelection: true,
      imageDefaultAlign: 'center',
      // imageEditButtons: [
      //   'imageReplace',
      //   'imageAlign',
      //   'imageRemove',
      //   '|',
      //   'imageLink',
      //   'linkOpen',
      //   'linkEdit',
      //   'linkRemove',
      //   '-',
      //   'imageDisplay',
      //   'imageStyle',
      //   'imageAlt',
      //   'imageSize'
      // ],
      imageEditButtons: ['imageAlign'],
      imageUpload: true,
      useClasses: false,
      imageDefaultDisplay: 'inline',
      events: {
        'commands.after': (cmd) => {
          if (cmd === 'screenshot') {
            this.handleScreenshot();
          }
        },
        initialized: function() {
          FroalaEditorRef.current = this;
          if (props?.hideToolbar) this.toolbar.hide();
          if (tribute && (props?.allowMentions || props?.allowPlaceholders)) {
            tribute.attach(this.el);

            this.events.on(
              'keydown',
              function(e) {
                if (e.key === 'Enter' && tribute.isActive) {
                  return false;
                }
                return true;
              },
              true
            );
          }
        },
        'image.beforeUpload': function(images) {
          this.image.showProgressBar();

          const uploadImage = (image, imageInstance = null) => {
            const formData = new FormData();
            formData.append('image', image);
            formData.append('module', props.module);
            formData.append('details', JSON.stringify(props.details));

            const requestOptions = {
              method: 'POST',
              credentials: 'include',
              body: formData,
              headers: getHeaderValue()
            };

            const getModuleURL = () => {
              switch (module) {
                default:
                  return `${envConfig.fileRoot}/inline_images`;
              }
            };
            EventEmitter.dispatch('imageUploading', true);

            fetchApi(getModuleURL(), requestOptions)
              .then((response) => {
                return response.json();
              })
              .then((result) => {
                if (result?.data?.link) {
                  const url = result.data.link;
                  this.image.insert(url, false, null, imageInstance, result);
                  console.log(result);
                } else {
                  this.image.remove(imageInstance);
                  toast('error', 'Upload failed');
                }
                return false;
              })
              .catch((error) => {});
            // .finally(() => EventEmitter.dispatch('imageUploading', false));
          };

          if (images.length > 1) {
            images.forEach((image) => {
              imagesLoading.push(image);
              uploadImage(image);
            });
          } else {
            imagesLoading.push(images[0]);

            const currentImage = this.image.get();

            uploadImage(images[0], currentImage);
          }
          return false;
        },
        'image.loaded': function($img) {
          if (imagesLoading.length === 1) {
            if (props.useTemplateFromProps) {
              if (imageUploadCompleteTimer) {
                clearTimeout(imageUploadCompleteTimer);
              }
              imageUploadCompleteTimer = setTimeout(() => {
                EventEmitter.dispatch('imageUploading', false);
              }, 1);
            } else {
              EventEmitter.dispatch('imageUploading', false);
            }
          }
          if (imagesLoading.length) imagesLoading.pop();
        },
        'image.removed': function($img) {
          // Do something here.
          // this is the editor instance.
          console.log('pvs:: removed', this, $img);
        },
        'image.uploaded': function(response) {
          // Do something here.
          // this is the editor instance.
          console.log('uploaded:: ', this, response);
        },
        'file.beforeUpload': function(files) {
          // Do something here.
          // this is the editor instance.
          console.log(this, files);
          // function updateFiles() {
          //   return false;
          // }
          // props.handleFileAttachments(files, updateFiles.bind(this));
          props.handleFileAttachments(files);
          return false;
          // setTimeout(() => {
          //   return false;
          // }, 500);
        },
        'file.uploaded': function() {
          console.log('uploaded');
          return false;
        },
        'filesManager.beforeUpload': function(files) {
          // Do something here.
          // this is the editor instance.
          console.log(this);
          props.handleFileAttachments(files);
          return false;
        },
        'customPlugin.showPopup': function() {
          console.log('pvs:: successssss');
        },
        blur: function() {
          this.selection.save();
        },
        focus: function() {
          if (this.selection) {
            // If the user clicks on the suggestion from Microsoft suggestion
            // It replaces the whole line instead of the word.
            // Reached out to Froala support team insisted to add timeout
            setTimeout(() => {
              this.selection.restore();
            }, 1);
          }
        }
      },
      toolbarSticky: props.toolbarSticky,
      charCounterCount: props.showCharacterCount || false,
      ...additionalConfig
    };
    this.state = {
      model: this.props?.template?.content,
      attachmentsModalOpen: false,
      addAttachmentsLoading: false,
      technicians: [],
      placeholdersUsed: props?.template?.placeholdersUsed || '{}',
      mentions: props?.template?.mentions || []
    };
    this.FroalaEditorRef = FroalaEditorRef;
    this.tempRef = tempRef;
  }

  insertEventEmitterIndex = null;
  replaceEventEmitterIndex = null;
  componentDidMount() {
    // if (this.props.setInstance) {
    //   this.props.setInstance(this);
    // }
    // setting ref directly in the parent and removing the setInstance state.
    if (
      this.props?.editorRef &&
      this.props.editorRef.hasOwnProperty('current')
    ) {
      this.props.editorRef.current = {
        ...this.props.editorRef.current,
        ...this
      };
    }
    setTimeout(() => {
      this.focusEditor();
      this.initialFocus();
    }, 200);

    if (this.props?.allowMentions) {
      const currentUser = this.context?.user || {};
      const userRole = currentUser?.role?.roleFeatureList || [];
      const isTechAuthorised = isAuthorised(userRole, 'employees.view');
      if (isTechAuthorised) {
        AccountClient.query({
          query: GET_ALL_TECHS_NEW,
          variables: {
            input: {
              listInfo: {
                sort: {
                  attribute: 'name',
                  order: 'ASC'
                }
              }
            }
          }
        }).then((res) => {
          if (res?.data?.getTechnicianList?.userList) {
            const allTechs = res.data.getTechnicianList.userList.map(
              (tech) => ({
                ...tech,
                key: tech.name,
                value: tech.userId
              })
            );

            this.techniciansList = allTechs;
            tribute?.append(0, allTechs);
          }
        });
      }
    }

    EventEmitter.subscribe('openCustomAttachments', this.openAttachmentsModal);
    EventEmitter.subscribe('insertOnlyEditorContent', this.insertTextOnly);
    EventEmitter.subscribe('insertEditorContent', this.insertText);
    this.insertEventEmitterIndex = EventEmitterWithIndex.subscribe(
      'insertOnlyEditorContent',
      this.insertTextOnly
    );
    this.insertEventEmitterIndex = EventEmitterWithIndex.subscribe(
      'insertEditorContent',
      this.insertText
    );
    this.replaceEventEmitterIndex = EventEmitterWithIndex.subscribe(
      'replaceEditorContent',
      this.replaceContent
    );
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps?.hideToolbar, this.props?.hideToolbar)) {
      if (this.props?.hideToolbar) {
        this.FroalaEditorRef?.current?.toolbar?.hide();
      } else {
        this.FroalaEditorRef?.current?.toolbar?.show();
      }
    }

    if (!isEqual(prevProps?.template?.content, this.props?.template?.content)) {
      // console.log('not equal');
      // this.setState({ model: this.props.template.content });
    }

    if (
      this.props?.allowPlaceholders &&
      !isEqual(prevProps?.placeholders, this.props?.placeholders)
    ) {
      tribute?.append(0, this.props?.placeholders);
      this.translatedMentionedPlaceholdersWrapper();
    }
  }

  componentWillUnmount() {
    EventEmitter.unsubscribe('insertEditorContent');
    EventEmitter.unsubscribe('insertOnlyEditorContent');
    EventEmitter.unsubscribe(
      'openCustomAttachments',
      this.openAttachmentsModal
    );
    if (
      this.insertEventEmitterIndex !== null &&
      this.insertEventEmitterIndex !== undefined
    ) {
      EventEmitterWithIndex.unsubscribe(
        'insertEditorContent',
        this.insertEventEmitterIndex
      );
    }

    if (
      this.replaceEventEmitterIndex !== null &&
      this.replaceEventEmitterIndex !== undefined
    ) {
      EventEmitterWithIndex.unsubscribe(
        'replaceEditorContent',
        this.replaceEventEmitterIndex
      );
    }

    if (this.updateTemplateTimer) {
      clearTimeout(this.updateTemplateTimer);
    }
  }

  updateTemplateTimer = null;

  updatePropsTemplateData = (updatedTemplate) => {
    if (this.props.useTemplateFromProps) {
      if (this.updateTemplateTimer) {
        clearTimeout(this.updateTemplateTimer);
      }
      this.updateTemplateTimer = setTimeout(() => {
        this.props.updateTemplate(updatedTemplate);
      }, UPDATE_TEMPLATE_TIMEOUT);
    } else {
      this.props.updateTemplate(updatedTemplate);
    }
  };

  openAttachmentsModal = () => {
    this.setState({ attachmentsModalOpen: true });
  };

  translatedMentionedPlaceholdersWrapper = () => {
    const currentPlaceHolders = cloneDeep(
      this.tempRef.current?.placeholdersUsed
    );
    const updatedPlaceholders = JSON.parse(currentPlaceHolders || '{}');

    const template = {
      placeholdersUsed: updatedPlaceholders
    };
    if (!template.placeholdersUsed.content) {
      template.placeholdersUsed.content = {};
    }
    template.placeholdersUsed.content = this.translatedMentionedPlaceholders();
    template.placeholdersUsed = JSON.stringify(template.placeholdersUsed);

    if (this.FroalaEditorRef.current) {
      const currentContent = this.FroalaEditorRef.current.html.get();
      template.content = currentContent;
    }
    if (this.props.useTemplateFromProps) {
      this.updatePropsTemplateData(template);
    } else {
      this.props.updateTemplate(template);
    }
  };

  translatedMentionedPlaceholders = () => {
    const mentionedPlaceholders = [];

    const mentions = document.querySelector(
      'span.mention[data-id][data-denotation-char="#"]'
    );
    const nodes = mentions?.children || [];

    const hasMentionDenotationChar = Array.from(nodes).some((child) =>
      child.classList.contains('ql-mention-denotation-char')
    );

    return Array.from(
      document.querySelectorAll(
        'span.mention[data-id][data-denotation-char="#"]'
      )
    ).reduce((acc, node) => {
      const localeId = node.getAttribute('data-id');
      node.setAttribute('contenteditable', 'false');

      const translatedValue = getTranslatedText(this.props.intl, localeId);

      /* Replacing the placeholders resolved values with current selected lang */

      const selector = hasMentionDenotationChar
        ? node.childNodes
        : node.querySelector('span')?.childNodes;

      // eslint-disable-next-line no-restricted-syntax
      for (const subNode of Array.from(selector || [])) {
        if (subNode.nodeName === '#text') {
          // eslint-disable-next-line no-param-reassign
          if (localeId.includes('udf')) {
            // Skip for custom field
            if (!acc[localeId]) {
              mentionedPlaceholders.push(localeId);
            }
            acc[localeId] = subNode.textContent;
            return acc;
          }
          subNode.textContent = translatedValue;
        }
      }

      if (node.getAttribute('data-value')) {
        node.setAttribute('data-value', translatedValue);
      }
      if (!acc[localeId]) {
        mentionedPlaceholders.push(localeId);
      }
      acc[localeId] = translatedValue;
      return acc;
    }, {});
  };

  handleModelChange = (model) => {
    const updatedPlaceholdersString = cloneDeep(
      this.tempRef.current?.placeholdersUsed
    );

    const updatedPlaceholders = JSON.parse(updatedPlaceholdersString);

    const updatedMentions = cloneDeep(this.tempRef.current?.mentions);

    const dummyDiv = document.createElement('div');
    dummyDiv.innerHTML = model;
    const template = {
      content: model
      // content: sanitizeString(model)
    };

    if (this.props?.allowMentions) {
      const mentionedItems = Array.from(
        new Set(
          Array.from(
            dummyDiv.querySelectorAll('span[data-id][data-denotation-char="@"]')
          ).map((item) => item.getAttribute('data-id'))
        )
      );

      const finalMentions = updatedMentions.filter((item) =>
        mentionedItems.includes(item?.userId)
      );

      template.mentions = finalMentions;
    }

    if (this.props?.allowPlaceholders) {
      updatedPlaceholders.content = Array.from(
        dummyDiv.querySelectorAll('span[data-id][data-denotation-char="#"]')
      ).reduce((acc, currentNode) => {
        const placeholderKey = currentNode.getAttribute('data-id');

        if (!placeholderKey) return acc;

        if (placeholderKey.includes('udf')) {
          // This is a custom field, No need to translate
          acc[placeholderKey] = currentNode.getAttribute('data-value');
          return acc;
        }

        acc[placeholderKey] = getTranslatedText(
          this.props.intl,
          placeholderKey
        );
        return acc;
      }, {});

      template.placeholdersUsed = JSON.stringify(updatedPlaceholders);
    }

    if (!this.props.useTemplateFromProps) {
      this.updateEditorContent(model);
      this.props.updateTemplate(template);
    } else {
      this.updatePropsTemplateData(template);
    }
  };

  updateEditorContent = (model) => {
    this.setState({ model: model });
  };

  handleFileAttachments = (files) => {
    console.log('files', files);
    if (
      !this.props?.template?.attachments?.length ||
      !this.props?.template?.attachmentList?.length
    )
      this.setState({ addAttachmentsLoading: true });
    this.props.handleFileAttachments(files, this.afterFileAttachments);
  };

  afterFileAttachments = () => {
    if (this.state.addAttachmentsLoading)
      this.setState({ addAttachmentsLoading: false });
  };

  handleScreenshot = () => {
    if (this.props.takeSnapshot) {
      this.props.takeSnapshot();
    }
  };

  insertText = (textContent) => {
    if (this.FroalaEditorRef.current && typeof textContent === 'string') {
      try {
        this.FroalaEditorRef.current.selection.restore();
      } catch (e) {
        console.log('Failed to focus and restore on editor');
      }

      this.FroalaEditorRef.current.html.insert(textContent);
      const updatedContent = this.FroalaEditorRef.current.html.get();
      if (this.props.updateTemplate) {
        this.props.updateTemplate({ content: updatedContent });
      }
    }
  };

  insertTextOnly = (textContent) => {
    if (this.FroalaEditorRef.current && typeof textContent === 'string') {
      try {
        setTimeout(() => {
          this.FroalaEditorRef.current.html.insert(textContent);
        }, 100);
      } catch (e) {}
    }
  };

  replaceText = (newContent) => {
    if (this.FroalaEditorRef.current && typeof textContent === 'string') {
      this.FroalaEditorRef.current.html.set(newContent);
    }
  };

  replaceContent = (newContent) => {
    if (newContent) {
      this.FroalaEditorRef.current.html.set(newContent);
      if (this.props.updateTemplate) {
        this.props.updateTemplate({ content: newContent });
      }
    }
  };

  focusEditor = () => {
    const isEditorEmpty = this.FroalaEditorRef.current?.core?.isEmpty();
    if (isEditorEmpty && this.props?.focusEditor) {
      this.FroalaEditorRef.current?.events?.focus();
    }
  };

  initialFocus = () => {
    if (this.props.shouldInitialFocus) {
      this.FroalaEditorRef.current?.events?.focus();
    }
  };

  render() {
    const { template, handleAttachmentsDeletion } = this.props;
    const attachments =
      this.props?.template?.attachments || this.props?.template?.attachmentList;
    const { attachmentsModalOpen } = this.state;

    const model = this.props.useTemplateFromProps
      ? this.props?.template?.content
      : this.state.model;
    return (
      <EditorWrapper
        hasAttachments={
          this.state.addAttachmentsLoading || attachments?.length > 0
        }
        className="full-height"
      >
        <FroalaEditor
          tag="textarea"
          config={this.config}
          model={model}
          onModelChange={this.handleModelChange}
        />
        {this.state.addAttachmentsLoading && !attachments?.length && (
          <AttachmentsHolder className="flex wrap" hasAttachments={1}>
            <Loader />
          </AttachmentsHolder>
        )}
        {attachments && (
          <AttachmentsHolder
            className="flex wrap"
            hasAttachments={attachments?.length > 0}
          >
            {attachments.map((attachment) => (
              <AttachmentItem
                fileName={attachment?.fileName}
                originalFileName={attachment?.originalFileName}
                fileSize={attachment?.fileSize}
                handleAttachmentsDeletion={handleAttachmentsDeletion}
                template={template}
                module={this.props.module}
                disableDownload={
                  module !== 'NOTIFICATION_TEMPLATE' ||
                  module !== 'TICKET_NOTIFICATION_TEMPLATE' ||
                  module !== 'ON_BOARDING_NOTIFICATION_TEMPLATE' ||
                  module !== 'REPLY_TEMPLATE' ||
                  module !== 'PROJECT_TEMPLATE'
                }
              />
            ))}
          </AttachmentsHolder>
        )}
        <CustomPromptModal
          allowMultiple={this.props?.singleFile ? false : true}
          title={this.props?.title || 'Add Attachments'}
          description={this.props?.description || 'Upload/drop files here'}
          active={attachmentsModalOpen}
          setActive={(val) => {
            this.setState({ attachmentsModalOpen: val });
          }}
          handleSubmit={this.handleFileAttachments}
          acceptType={this.props?.acceptType} // For single select to accept only given file types
          acceptAllType={this.props?.acceptAllType} // For single select to accept all type
        />
      </EditorWrapper>
    );
  }
}

Editor.defaultProps = {
  disableAttachment: false,
  toolbarSticky: true
};

export default withErrorBoundary(injectIntl(Editor));
